<template>
  <v-main>
    <v-container fluid fill-height>
      <v-layout column align-center justify-center>
        <v-card width="717" class="mb-3">
          <v-card-title>Plan Details</v-card-title>
          <v-divider></v-divider>
          <v-card-title class="font-weight-regular">{{transactionObj.phoneNumber.friendlyName}}</v-card-title>
          <v-card-text>
            <div v-if="transactionObj" class="pl-1">
              <h3 class="font-weight-Bold pt-2 mb-1">Activation date:</h3>
              <h3 class="font-weight-regular mb-1">{{formattedDate(todaysDate)}}</h3>
              <h3 class="font-weight-bold mb-1">Renewal date:</h3>
              <h3 class="font-weight-regular mb-1">{{thirtyDaysFromNow}}</h3>
            </div>
          </v-card-text>
          <v-card-text>
            <div v-if="transactionObj" class="pl-1">
              <h3 class="font-weight-bold mb-1">Rates:</h3>
              <h3 class="font-weight-regular pt-2 mb-1"><v-icon>numbers</v-icon>  Phone Line: ${{transactionObj.rates.costPerNumber}} /month</h3>
              <h3 class="font-weight-regular mb-1"><v-icon>phone</v-icon> Calls: ${{transactionObj.rates.costPerCall}}/min</h3>
              <h3 class="font-weight-regular mb-1"><v-icon>sms</v-icon>  SMS: ${{transactionObj.rates.costPerSMS}}/text</h3>
            </div>
          </v-card-text>
        </v-card>
        <v-flex xs12 sm12 md12 lg12>
          <user-billing-address></user-billing-address>
        </v-flex>
        <v-flex v-if="transactionObj" xs12 sm8 md8 lg8>
          <v-card width="717" v-if="!stripeObj" class="elevation-1 mt-3">
            <v-card-title>Payment Method</v-card-title>
            <v-divider></v-divider>
            <v-img
                class="mt-6"
                height="50"
                contain
                src="https://firebasestorage.googleapis.com/v0/b/flexline-app.appspot.com/o/Logo%2Fstripe_logo_credit_card.png?alt=media&token=2e139d67-0ac6-4cf6-99ee-041e0560beb3"
            ></v-img>
            <v-card-subtitle>Enter Card Details</v-card-subtitle>
            <v-card-text>
              <stripe-element-card
                  ref="elementRef"
                  :pk="publishableKey"
                  @token="tokenCreated"
                  @element-change="cardStatus"
              />
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :disabled="!inputValid" class="mt-3 mb-3 blue" block dark @click="submit">Charge Card</v-btn>
            </v-card-actions>
            <v-card-subtitle>Payment security provided by <a href="https://stripe.com/en-ca/privacy" class="black--text">Stripe.</a>
            </v-card-subtitle>
          </v-card>
          <v-card v-else >
            <v-card-text>
              <v-row>
                <v-col
                    cols="12"
                    md="6"
                >
                  <v-item>
                    <v-card
                        height="220"
                        @click="openChargeCardDialog"
                        class="elevation-12 light-blue white--text"
                        style="background:linear-gradient(135deg, #13f1fc 0%,#099ce7 100%);"
                    >
                      <v-card-title>
                          <v-icon class="mr-2 white--text">credit_card</v-icon>
                          {{stripeObj.card.brand}}
                      </v-card-title>
                      <v-card-subtitle class="display-1 white--text">****{{stripeObj.card.last4}}</v-card-subtitle>
                      <v-card-actions>
                      <v-spacer></v-spacer>
                        <v-card-subtitle class="headline white--text">
                          Expires: {{stripeObj.card.exp_month}}/{{stripeObj.card.exp_year}}
                        </v-card-subtitle>
                      </v-card-actions>
                      </v-card>
                  </v-item>
                </v-col>
                <v-col
                    cols="12"
                    md="4"
                >
                  <v-item>
                    <v-card
                        height="100"
                        @click="stripeObj = null"
                    >
                      <v-card-title><v-icon>add</v-icon><v-icon class="mr-2">credit_card</v-icon>
                        Add new card
                      </v-card-title>
                    </v-card>
                  </v-item>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-subtitle>Payment security provided by <a href="https://stripe.com/en-ca/privacy">Stripe.</a>
            </v-card-subtitle>
          </v-card>
        </v-flex>
        <v-flex v-else xs12 sm8 md8 lg8>
          <v-card  class="elevation-1">
            <v-card-title>Transaction Failed</v-card-title>
            <v-card-text>
             <v-icon class="red--text">cancel</v-icon>Go back to Booking and begin payment process.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="chargeCardDialog"
              persistent
              max-width="300"
    >
      <v-card v-if="transactionObj">
        <v-card-title v-if="transactionObj.id === 'flexlinePhoneNumber'" class="text-h5">
          <v-icon>receipt</v-icon> {{transactionObj.title}}
        </v-card-title>
        <v-card-text v-if="transactionObj.id === 'flexlinePhoneNumber'" >
          <div class="headline">
            <v-icon>attach_money</v-icon> {{transactionObj.rates.costPerNumber}}
          </div>
          <div>
            Will be charged on
          </div>
          <div v-if="stripeObj">
            {{stripeObj.card.brand}} ****{{stripeObj.card.last4}} Expires: {{stripeObj.card.exp_month}}/{{stripeObj.card.exp_year}}
          </div>
        </v-card-text>
        <v-card-text v-if="transactionObj">
          <div>
            <v-btn class="green" dark block @click="chargeCardOnFile">Charge card</v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
              block
              text
              @click="chargeCardDialog = false"
          >
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>

<script>
import {v1 as uuidv1} from 'uuid';
import {StripeElementCard} from '@vue-stripe/vue-stripe';
import {doc, onSnapshot} from "firebase/firestore";
import moment from 'moment';

export default {
  components: {
    StripeElementCard,
  },
  data () {
    return {
      publishableKey: 'pk_test_51OHKXSC5wLMgkrcWf6bVEbf4jeGrggINKHYDEsqgC6jEM8DYtvvN4XYXWN7uDkXdpUwFuZaeevXszN9l82iFvTKe00dRZ5UZgu',
      // publishableKey: 'pk_live_51OHKXSC5wLMgkrcWzdA8R5OjaKEn6HFCacJf8obipi2rX34gawyllxZ44gPnTeN7eiGwnbdhua88vGhYwA7LK16N00nPf2f45B',
      token: null,
      inputValid: false,
      stripeObj: null,
      chargeCardDialog: false,
      todaysDate: Date.now()
    };
  },

  computed: {
    formattedDate () {
      return (date) => {
        let day = moment(date).format('ddd, Do MMM YYYY')
        return day
      }
    },
    thirtyDaysFromNow () {
      let today = Date.now()
      // console.log(today)
      let thirtyDaysFromNow = today + 2629743000
      // console.log(thirtyDaysFromNow)
      return moment(thirtyDaysFromNow).format('ddd, Do MMM YYYY')
    },
    transactionObj () {
      return this.$store.getters.billingTransactionObj
    },
    billingObj () {
      return this.$store.getters.billingAddress
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  // created () {
  //   console.log(this.billingObj)
  // },
  methods: {
    chargeCardOnFile () {
      //console.log(this.stripeObj)
      let payload = this.transactionObj
      payload.stripeObj = this.stripeObj
      payload.chargeType = 'cardOnFile'
      this.chargeCardDialog = false
      // this.$store.dispatch('chargeCardOnFile', payload)
    },
    getStripeObj () {
      let db = this.$store.state.db
      let uid = this.user.uid
      let phoneNumber =  this.orderData.clientInfo.phoneNumber
      let email = this.orderData.clientInfo.email
      let cardesRef
      if (phoneNumber) {
        cardesRef = doc(db, 'users', uid
            + '/cardPayments/stripe/cards/' + phoneNumber)
      }
      if (!phoneNumber && email) {
        cardesRef = doc(db, 'users', uid
            + '/cardPayments/stripe/cards/' + email)
      }
      onSnapshot(cardesRef, res => {
        if (res.exists) {
          this.stripeObj = res.data()
          // console.log(this.stripeObj)
        }
      })
    },
    openChargeCardDialog () {
      this.chargeCardDialog = true
    },
    submit () {
      // this will trigger the process
      this.$refs.elementRef.submit();
    },
    tokenCreated (token) {
      // console.log(token);
      let chargeObject = {chargeToken: token, chargeType: 'newCard'}
      let invoiceObj = {id: uuidv1(), created: this.todaysDate}
      let subDetail = this.transactionObj
      if (this.transactionObj.type === 'twilio') {
        invoiceObj.title = 'New Number Subscription'
        invoiceObj.billingDate = this.formattedDate(this.todaysDate)
        invoiceObj.nextBillingDate = this.thirtyDaysFromNow
        invoiceObj.message = 'Your new line: ' + this.transactionObj.phoneNumber.friendlyName + ' is now active!'
        invoiceObj.contactName = this.billingObj.name
        invoiceObj.contactAddress = this.billingObj.address +' '
            + this.billingObj.city + ' '
            + this.billingObj.state + ' '
            + this.billingObj.zip + ' '
            + this.billingObj.country + ' '
        invoiceObj.lineItems = [
          {title: 'Voice ($/min)', price: subDetail.rates.costPerCall},
          {title: 'SMS ($/text)', price: subDetail.rates.costPerSMS},
          {title: 'Phone line ($/month)', price: subDetail.rates.costPerNumber},
        ]
        invoiceObj.totalPaid = subDetail.rates.costPerNumber
      }
      // console.log(this.billingObj)
      subDetail.startDate = this.formattedDate(this.todaysDate)
      subDetail.created = this.todaysDate
      chargeObject.subscription = subDetail
      chargeObject.created = this.todaysDate
      chargeObject.invoice = invoiceObj


      console.log(chargeObject)
      this.$store.dispatch('newBillingCardPaymentMade', chargeObject)
    },
    cardStatus (status) {
      this.inputValid = !!status.complete
    }
  }
};
</script>